<template>
    <v-container fluid>
        <div class="ml-4">
            <v-container>
                <similiarity-check
                    :tryouts="tryouts"
                    v-model="similiarities"
                    ref="similiarityCheck"
                ></similiarity-check>

                <upload-and-download-button
                    v-model="tryouts"
                ></upload-and-download-button>
            </v-container>
        </div>

        <v-tabs v-model="tab">
            <v-tab v-for="(tryout, idx) in tryouts" :key="idx">
                <v-badge
                    :value="similiarities[idx] !== undefined"
                    dot
                    color="red"
                    style="max-width: 95%"
                >
                    <div
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis"
                    >
                        {{ tryout.tryout.title }} - {{ tryout.period.title }}
                    </div>
                </v-badge>
            </v-tab>

            <v-tab @click="resetTryoutSelector">
                <v-icon left>mdi-plus</v-icon>
                tambah
            </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item v-for="(tryout, idx) in tryouts" :key="idx">
                <v-card flat>
                    <v-card-text>
                        <check-import-tryout
                            @similiarityChange="
                                $refs.similiarityCheck.checkLocalSimiliarities()
                            "
                            v-model="tryouts[idx].questions"
                            :similiarities="similiarities"
                            :tryouts="tryouts"
                            :tryoutIdx="idx"
                        ></check-import-tryout>
                    </v-card-text>
                </v-card>
            </v-tab-item>

            <v-tab-item>
                <select-tryout
                    @add="applyNewTryout"
                    ref="tryoutSelector"
                    keep-alive
                ></select-tryout>
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</template>

<script>
import SelectTryout from './components/SelectTryout.vue'
import CheckImportTryout from './components/CheckImportTryout.vue'
import SimiliarityCheck from './components/SimiliarityCheck.vue'
import UploadAndDownloadButton from './components/UploadAndDownloadButton.vue'

export default {
    components: {
        SelectTryout,
        CheckImportTryout,
        SimiliarityCheck,
        UploadAndDownloadButton
    },

    data: () => ({
        tab: null,
        tryouts: [],
        similiarities: {}
    }),

    methods: {
        resetTryoutSelector() {
            this.$refs.tryoutSelector.reset()
        },

        applyNewTryout(tryout) {
            tryout.questions = []
            this.tryouts.push(tryout)
            this.tab = this.tryouts.length
        }
    }
}
</script>
